import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

export const isPartOfProductCardRatingsReviewsLIHPExperiment = () =>
  GrowthDiscoveryExperiments.get('showRatingsandReviewsOnLIHPProductCards') === true;
